import React, { useEffect, useRef, useState } from "react";

const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .es-page {
    background: #060608;
    color: #fff;
    font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', sans-serif;
    min-height: 100vh;
    overflow-x: hidden;
  }

  .es-noise {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    opacity: 0.025;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
    background-size: 128px;
  }

  .es-container {
    max-width: 860px;
    margin: 0 auto;
    padding: 0 28px;
    position: relative;
    z-index: 1;
  }

  .es-hero {
    padding: 100px 0 80px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  .es-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #7a27b5;
    margin-bottom: 28px;
  }

  .es-eyebrow-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #7a27b5;
    animation: es-pulse 2s infinite;
  }

  @keyframes es-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.4; transform: scale(0.8); }
  }

  .es-h1 {
    font-size: clamp(34px, 5.5vw, 60px);
    font-weight: 700;
    line-height: 1.06;
    letter-spacing: -0.03em;
    color: #fff;
    margin: 0 0 24px;
  }

  .es-h1 em {
    font-style: normal;
    color: #7a27b5;
  }

  .es-hero-sub {
    font-size: 17px;
    color: rgba(255,255,255,0.85);
    line-height: 1.7;
    max-width: 580px;
    margin: 0 0 40px;
    font-weight: 300;
  }

  .es-meta-row {
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
  }

  .es-meta-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .es-meta-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.4);
  }

  .es-meta-val {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255,255,255,0.9);
  }

  .es-hero-video-section {
    padding: 48px 0 72px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  .es-hero-video-section video {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 16px;
    border: 1px solid rgba(34,197,94,0.2);
    box-shadow: 0 8px 48px rgba(0,0,0,0.5);
    background: #000;
  }

  .es-section {
    padding: 72px 0;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    opacity: 0;
    transform: translateY(24px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }

  .es-section.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .es-section-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #7a27b5;
    margin-bottom: 16px;
  }

  .es-big-heading {
    font-size: clamp(32px, 5vw, 56px);
    font-weight: 700;
    letter-spacing: -0.03em;
    color: #fff;
    line-height: 1.06;
    margin: 0 0 36px;
  }

  .es-body {
    font-size: 16px;
    color: rgba(255,255,255,0.9);
    line-height: 1.75;
    font-weight: 300;
    max-width: 640px;
    margin-bottom: 36px;
  }

  .es-step-badge {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
  }

  .es-step-num {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #7a27b5;
    color: #000;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .es-step-lbl {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #7a27b5;
  }

  .es-img-row {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .es-img-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 14px;
    overflow: hidden;
    cursor: zoom-in;
    position: relative;
    transition: border-color 0.25s, box-shadow 0.25s, transform 0.25s;
    box-shadow: 0 4px 24px rgba(0,0,0,0.3);
  }

  .es-img-card:hover {
    border-color: rgba(34,197,94,0.35);
    box-shadow: 0 12px 48px rgba(34,197,94,0.12), 0 4px 16px rgba(0,0,0,0.4);
    transform: translateY(-3px);
  }

  .es-img-card::after {
    content: 'expand';
    position: absolute;
    top: 12px; right: 14px;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    background: rgba(34,197,94,0.75);
    padding: 4px 10px;
    border-radius: 7px;
    opacity: 0;
    transition: opacity 0.2s;
    letter-spacing: 0.05em;
  }

  .es-img-card:hover::after { opacity: 1; }

  .es-img-card img {
    width: 100%;
    height: 320px;
    object-fit: cover;
    object-position: top center;
    display: block;
    transition: transform 0.35s ease;
  }

  .es-img-card:hover img { transform: scale(1.02); }

  .es-img-caption {
    padding: 14px 18px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    letter-spacing: 0.02em;
    line-height: 1.5;
    border-top: 1px solid rgba(255,255,255,0.06);
    background: rgba(34,197,94,0.06);
  }

  .es-quote-section {
    padding: 72px 0;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  .es-quote-block {
    border-left: 3px solid #7a27b5;
    padding: 22px 30px;
    background: rgba(34,197,94,0.04);
    border-radius: 0 12px 12px 0;
    max-width: 680px;
    margin-top: 36px;
  }

  .es-quote-text {
    font-size: clamp(18px, 2.4vw, 24px);
    font-style: italic;
    color: #fff;
    line-height: 1.5;
    font-weight: 300;
    letter-spacing: -0.01em;
  }

  .es-quote-attr {
    margin-top: 14px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #7a27b5;
  }

  .es-guarantee-section {
    padding: 72px 0;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  .es-guarantee-box {
    margin-top: 36px;
    background: rgba(34,197,94,0.05);
    border: 1px solid rgba(34,197,94,0.2);
    border-radius: 18px;
    padding: 36px 40px;
    display: flex;
    gap: 22px;
    align-items: flex-start;
    position: relative;
    overflow: hidden;
  }

  .es-guarantee-box::before {
    content: '';
    position: absolute;
    top: -60px; right: -60px;
    width: 220px; height: 220px;
    background: radial-gradient(circle, rgba(34,197,94,0.08), transparent 70%);
    pointer-events: none;
  }

  .es-guarantee-icon { font-size: 32px; flex-shrink: 0; line-height: 1; }

  .es-guarantee-title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 10px;
    letter-spacing: -0.01em;
  }

  .es-guarantee-text {
    font-size: 15px;
    color: rgba(255,255,255,0.9);
    line-height: 1.7;
    font-weight: 300;
  }

  .es-guarantee-text strong { color: #7a27b5; font-weight: 600; }

  .es-cta-section { padding: 80px 0 100px; }

  .es-cta-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    padding: 56px 48px;
    text-align: center;
    position: relative;
    overflow: hidden;
  }

  .es-cta-card::before {
    content: '';
    position: absolute;
    bottom: -80px; left: 50%; transform: translateX(-50%);
    width: 500px; height: 260px;
    background: radial-gradient(ellipse, rgba(34,197,94,0.1), transparent 70%);
    pointer-events: none;
  }

  .es-cta-h2 {
    font-size: clamp(26px, 4vw, 40px);
    font-weight: 700;
    letter-spacing: -0.025em;
    color: #fff;
    margin: 0 0 14px;
    line-height: 1.15;
    position: relative;
  }

  .es-cta-sub {
    font-size: 15px;
    color: rgba(255,255,255,0.8);
    line-height: 1.7;
    max-width: 460px;
    margin: 0 auto 36px;
    font-weight: 300;
    position: relative;
  }

  .es-cta-steps {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 40px;
    position: relative;
  }

  .es-cta-step {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 18px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
  }

  .es-cta-step-num {
    width: 24px; height: 24px;
    border-radius: 50%;
    background: #7a27b5;
    color: #000;
    font-size: 11px;
    font-weight: 700;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
  }

  .es-cta-step-text { font-size: 13px; color: rgba(255,255,255,0.85); font-weight: 500; }

  .es-cta-btn {
    display: inline-block;
    background: #7a27b5;
    color: #000;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.01em;
    padding: 18px 52px;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.15s;
    text-decoration: none;
    position: relative;
  }

  .es-cta-btn:hover { opacity: 0.88; transform: translateY(-1px); }

  .es-cta-fine {
    font-size: 13px;
    color: rgba(255,255,255,0.5);
    margin-top: 16px;
    font-weight: 300;
    position: relative;
  }

  .es-lightbox {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.92);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    animation: lbIn 0.2s ease;
    backdrop-filter: blur(8px);
  }

  @keyframes lbIn { from { opacity: 0; } to { opacity: 1; } }

  .es-lightbox-inner {
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    animation: lbPop 0.24s cubic-bezier(0.34,1.56,0.64,1);
  }

  @keyframes lbPop {
    from { transform: scale(0.88); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }

  .es-lightbox-inner img {
    max-width: 90vw;
    max-height: 85vh;
    border-radius: 16px;
    display: block;
    box-shadow: 0 32px 100px rgba(0,0,0,0.7);
  }

  .es-lightbox-close {
    position: absolute;
    top: -14px; right: -14px;
    width: 34px; height: 34px;
    border-radius: 50%;
    background: #7a27b5;
    color: #000;
    font-size: 18px;
    border: none;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    font-weight: 700;
    box-shadow: 0 4px 16px rgba(34,197,94,0.5);
    transition: background 0.2s, transform 0.15s;
    line-height: 1;
  }

  .es-lightbox-close:hover { background: #7a27b5; transform: scale(1.1); }

  .es-lightbox-caption {
    text-align: center;
    margin-top: 14px;
    font-size: 14px;
    color: #7a27b5;
    font-weight: 500;
    letter-spacing: 0.04em;
  }

  @media (max-width: 620px) {
    .es-cta-card { padding: 36px 20px; }
    .es-cta-steps { flex-direction: column; align-items: center; }
    .es-guarantee-box { flex-direction: column; padding: 24px 20px; }
    .es-img-card img { height: 200px; }
  }
`;

function useReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.08 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
}

function Section({ children }) {
  const [ref, visible] = useReveal();
  return (
    <div ref={ref} className={`es-section ${visible ? "visible" : ""}`}>
      {children}
    </div>
  );
}

function Lightbox({ src, label, onClose }) {
  useEffect(() => {
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);
  return (
    <div className="es-lightbox" onClick={onClose}>
      <div className="es-lightbox-inner" onClick={(e) => e.stopPropagation()}>
        <button className="es-lightbox-close" onClick={onClose}>×</button>
        <img src={src} alt={label} />
        {label && <p className="es-lightbox-caption">{label}</p>}
      </div>
    </div>
  );
}

function ImgCard({ src, label }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="es-img-card" onClick={() => setOpen(true)} title="Click to expand">
        <img src={src} alt={label} loading="lazy" onError={(e) => { e.target.style.display = "none"; }} />
        {label && <div className="es-img-caption">{label}</div>}
      </div>
      {open && <Lightbox src={src} label={label} onClose={() => setOpen(false)} />}
    </>
  );
}

const PAYMENT_LINK = "https://buy.stripe.com/14A7sM0EO84e0KFfjr0sU03";
const CRM_VIDEO = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/videos/CRM%20video.mp4";

export default function First30Days() {
  return (
    <div className="es-page">
      <style>{styles}</style>
      <div className="es-noise" />

      <div className="es-container">

        {/* HERO */}
        <div className="es-hero">
          <div className="es-eyebrow">
            <span className="es-eyebrow-dot" />
            30-Day Pilot Campaign · Reflex
          </div>
          <h1 className="es-h1">
            Your First 30 Days<br />
            <em>With Reflex</em>
          </h1>
          <p className="es-hero-sub">
            We build your complete growth system in 30 days — outreach, automation, CRM, email, and social media — all running together to bring you real leads and customers. You focus on your business. We handle the rest.
          </p>
          <div className="es-meta-row">
            {[
              { label: "Agency", val: "Reflex" },
              { label: "Investment", val: "$450" },
              { label: "Duration", val: "30 Days" },
              { label: "Guarantee", val: "Results or Free" },
            ].map((m) => (
              <div key={m.label} className="es-meta-item">
                <span className="es-meta-label">{m.label}</span>
                <span className="es-meta-val">{m.val}</span>
              </div>
            ))}
          </div>
        </div>

        {/* HERO VIDEO */}
        <div className="es-hero-video-section">
          <video autoPlay muted loop playsInline controls>
            <source src={CRM_VIDEO} type="video/mp4" />
          </video>
        </div>

        {/* WHAT WE BELIEVE */}
        <div className="es-quote-section">
          <h2 className="es-big-heading">What We Believe</h2>
          <div className="es-quote-block">
            <p className="es-quote-text">
              "A sale is not completed until the customer receives the result."
            </p>
            <p className="es-quote-attr">— Reflex, Core Principle</p>
          </div>
        </div>

        {/* GUARANTEE */}
        <div className="es-guarantee-section">
          <h2 className="es-big-heading">Our Guarantee</h2>
          <div className="es-guarantee-box">
            <div className="es-guarantee-icon">🛡️</div>
            <div>
              <p className="es-guarantee-title">Zero-Risk Commitment</p>
              <p className="es-guarantee-text">
                If no measurable results are achieved during the 30-day pilot,{" "}
                <strong>we continue working for free</strong> until the system delivers outcomes.
                We are fully committed to your growth.
              </p>
            </div>
          </div>
        </div>

        {/* STEP 1 */}
        <Section>
          <div className="es-step-badge">
            <div className="es-step-num">1</div>
            <span className="es-step-lbl">Step 1</span>
          </div>
          <h2 className="es-big-heading">Outbound Calling System</h2>
          <p className="es-body">
            We build a targeted lead list of high-quality prospects relevant to your business — including property managers, commercial clients, and other decision-makers in your industry. Using a power dialer, we run outbound calls at scale to book meetings and generate real interest in your services from day one.
          </p>
          <div className="es-img-row">
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/5000%20property%20leads.png" label="5000+ targeted leads ready for outreach" />
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/power%20dialer.png" label="Power dialer system — 450–500 calls per day" />
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/powerdialer.png" label="Power dialer session in action" />
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/dashboard%20daily%20calls.png" label="Daily call dashboard — track volume and outcomes" />
          </div>
        </Section>

        {/* STEP 2 */}
        <Section>
          <div className="es-step-badge">
            <div className="es-step-num">2</div>
            <span className="es-step-lbl">Step 2</span>
          </div>
          <h2 className="es-big-heading">Custom HTML Email Templates</h2>
          <p className="es-body">
            We design branded HTML email templates for your business — used for promotions, special offers, or service packages. These look professional, load correctly on all devices, and represent your business the right way every time they land in an inbox.
          </p>
          <div className="es-img-row">
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/html%20template%20email.png" label="Custom branded HTML email template" />
          </div>
        </Section>

        {/* STEP 3 */}
        <Section>
          <div className="es-step-badge">
            <div className="es-step-num">3</div>
            <span className="es-step-lbl">Step 3</span>
          </div>
          <h2 className="es-big-heading">Email Automation</h2>
          <p className="es-body">
            We set up full automation workflows for your business — emails, SMS, follow-ups, and triggers all running automatically. Leads stay connected with your business every day without you lifting a finger. Everything is built once and runs on its own.
          </p>
          <div className="es-img-row">
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/email%20marketing.png" label="Email marketing overview — open rates, clicks, and performance" />
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/email%20automation.png" label="Automated email sequence builder — every follow-up sent without manual effort" />
          </div>
        </Section>

        {/* STEP 4 */}
        <Section>
          <div className="es-step-badge">
            <div className="es-step-num">4</div>
            <span className="es-step-lbl">Step 4</span>
          </div>
          <h2 className="es-big-heading">CRM & Lead Management</h2>
          <p className="es-body">
            We set up a full CRM for your business to keep every lead organized and moving forward. Follow-ups, calls, reminders, and nurturing sequences are all handled inside the system — so no lead falls through the cracks and every opportunity gets the attention it deserves.
          </p>
          <div className="es-img-row">
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/opportunity.png" label="Opportunity pipeline — full visibility of every active deal" />
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/closed%20deals.png" label="Closed deals tracker — revenue won and contracts signed" />
          </div>
        </Section>

        {/* STEP 5 */}
        <Section>
          <div className="es-step-badge">
            <div className="es-step-num">5</div>
            <span className="es-step-lbl">Step 5</span>
          </div>
          <h2 className="es-big-heading">Social Media Growth</h2>
          <p className="es-body">
            We manage your social media pages — content, replies, posting strategy, and growth. Everything connects back to your CRM so new followers and inquiries flow directly into your pipeline. Your audience grows consistently without you needing to post every day.
          </p>
          <div className="es-img-row">
            <ImgCard src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/social%20media%20growth.png" label="Automated system for social media growth" />
          </div>
        </Section>

        {/* STEP 6 */}
        <Section>
          <div className="es-step-badge">
            <div className="es-step-num">6</div>
            <span className="es-step-lbl">Step 6</span>
          </div>
          <h2 className="es-big-heading">Video Content</h2>
          <p className="es-body">
            We provide engaging reel content designed to increase views, reach, and customer engagement. We also handle professional video editing so your content looks polished, high quality, and worth sharing — building trust with your audience at every touchpoint.
          </p>
        </Section>

        {/* FINAL CTA */}
        <div className="es-cta-section">
          <div className="es-cta-card">
            <p className="es-section-label" style={{ textAlign: "center" }}>Get Started</p>
            <h2 className="es-cta-h2">Start your growth<br />system today.</h2>
            <p className="es-cta-sub">
              30 days. The full system. Real leads. If it doesn't deliver — we keep working for free. There's no easier way to test this.
            </p>
            <div className="es-cta-steps">
              {["Pay for pilot", "We build the system", "Leads start flowing"].map((step, i) => (
                <div key={i} className="es-cta-step">
                  <div className="es-cta-step-num">{i + 1}</div>
                  <span className="es-cta-step-text">{step}</span>
                </div>
              ))}
            </div>
            <a href={PAYMENT_LINK} target="_blank" rel="noopener noreferrer" className="es-cta-btn">
              Start 30-Day Pilot — $450 →
            </a>
            <p className="es-cta-fine">No long-term contracts. Results guaranteed or we work for free.</p>
          </div>
        </div>

      </div>
    </div>
  );
}